import { handleResponse, request } from "@/hooks/request";
import type { User } from "@/types/user";

const UserApi = {
  fetchUser: (assignment_id: string, email: string, abort_signal?: AbortSignal) => {
    return request(`/api/user/assignment/${assignment_id}/${email}`, {
      signal: abort_signal,
    }).then(handleResponse<User>);
  },
  sendInvite: (user_email: string, assignment_id: string, abort_signal?: AbortSignal) => {
    return request("/api/user/invite", {
      method: "post",
      body: JSON.stringify({
        user_email,
        assignment_id,
        origin: window.location.origin,
      }),
      signal: abort_signal,
    }).then(handleResponse);
  },
};

export default UserApi;
